<template>
  <tr>
    <td>
      <div class="height width">
        <BaseInput
          v-if="item"
          height="48px"
          :rules="['required']"
          v-model="item.value"
          :measure="translation['euro_hour']"
          :view="!edit"
          :view-value="$formatCurrency(item?.value)  + ' ' + translation['euro_hour']"
          input-type="Number"
        />
      </div>
    </td>
    <td>
      {{ item?.changer?.full_name || '' }}
    </td>
    <td>
      {{ item?.updated_at || ''}}
    </td>
  </tr>
</template>

<script>
export default {
  name: "SalaryTableItems",
  props: {
    item: [Array, Object],
    edit: Boolean,
  },
  computed: {
    translation() {
      return this.localStorage.translations.pages['setting-personal_area'].labels
    },
  },
}
</script>

<style scoped lang="scss">
:deep() .v-input .v-input__append-outer {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>